import React from 'react';
import { Grid } from 'fw/forms';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import TimeSummaryValueFormatter from 'areas/shared/components/formatter/TimeSummaryValueFormatter';

class TimeSummary extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
			list: [],
			dateFrom: null,
			dateTo: null
		};
	}

	componentDidMount() {
		this.handleSearch();
	}

	handleSearch = (filters, callback) => {
		this.setState({
			list: []
		}, function () {
			this.search(null, callback);
		});
	}

	search = (opts, callback) => {
		const rq = Object.assign({});

		var state = {
			list: []
		};

		new API().post(APIModules.Admin.url(this.props.endpoint), rq,
			{
				success: (r) => {
					const items = r.data.items || [];
					const dateFrom = r.data.dateFrom;
					const dateTo = r.data.dateTo;

					state = {
						list: items.map((item, index) => ({ ...item, id: index + 1, dateFrom, dateTo })),
						dateFrom,
						dateTo
					};

					// Store search results
					this.setState(state);

					// Callback
					if (callback)
						callback();
				}
			});

		return state;
	}

	render() {
		// Update columns with dynamic header name
		const dynamicColumns = [
			{ key: 'label', name: this.props.title, width: 140, sortable: false },
			{ key: 'value', name: 'Totals', formatter: TimeSummaryValueFormatter, getRowMetaData: (row) => row, sortable: false }
		];

		return (
			<React.Fragment>
				<div className={this.props.className}>
					<Grid
						columns={dynamicColumns}
						items={this.state.list}
						height={212}
						rowKey="id"
						name="default" />
				</div>
				<table className={`dashboard-print-table time-summary-print ${this.props.className}-print`}>
					<thead>
						<tr>
							<th>{this.props.title}</th>
							<th>Totals</th>
						</tr>
					</thead>
					<tbody>
						{this.state.list.map((row, i) => (
							<tr key={i}>
								<td>{row.label}</td>
								<td>{row.value || (row.isCurrency ? '$0.00' : '0')}</td>
							</tr>
						))}
					</tbody>
				</table>
			</React.Fragment>
		)
	}
}

export default TimeSummary;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDashboard/timeSummary/TimeSummary.js